/* @flow strict */

const ServiceMsg = () => {
  console.clear();

  if (process.env.VERBOSE_LOG === 'true') {
    console.log(
      '%cSPARXO',
      'font: 3em sans-serif; font-weight: bold; color: #f84171; padding: 0 15px;'
    );

    // TODO Fix reading from package.json
    console.log(`Version ${process.env.VERSION}`);

    const serviseMessage = (mode: string): string => `SPARXO APP RUNNING IN ${mode} MODE`;

    console.info(serviseMessage('DEVELOPMENT'));
  } else {
    console.log(
      '%cSPARXO',
      'font: 3em sans-serif; font-weight: bold; color: #f84171; padding: 0 15px;'
    );
    console.group(
      '%cRules of conduct in the console',
      'font: 1em sans-serif; font-weight: bold; color: #4a89dc; padding: 0 15px;'
    );

    console.log('- don\'t try to break');
    console.log('- big brother is watching you :)');
    console.log('- сlose the console and use the project as intended');

    console.groupEnd();

    console.log(
      '%cWhoever you are, have a nice day ;)',
      'font: 1.25em sans-serif; font-weight: bold; color: #707070; padding: 0 15px;'
    );

    // eslint-disable-next-line
    console = {
      info: () => {},
      log: () => {},
      error: () => {},
      warn: () => {}
    };
  }
};

export default ServiceMsg;
